export default __webpack_public_path__ + "0914ac39aab55858c22caab69213b1fa.png";